module.exports = __webpack_public_path__ + "img/body-bottom.a352699a.png";